// React libraries
import React, { useEffect, useState } from "react";
// Custom Styles
import { useStyles } from "./InventoryCountingBinLocationsPageStyles";
// Material-UI Core
import { Grid } from "@mui/material";
import BlueGradientHeader from "../BlueGradientHeader";
import PageWrapper from "../PageWrapper";
import GreyButton from "../GreyButton";
import ScanContentBar from "../ScanContentBar";
export const InventoryCountingBinLocationsPage = (props) => {
    const classes = useStyles(props);
    const { previewWidth, previewHeight, data, scanContentBarText, isListPrefilled } = props;
    const [binLocationList, setBinLocationList] = useState(data);
    useEffect(() => {
        setBinLocationList(data);
    }, [data]);
    return (React.createElement(PageWrapper, { previewHeight: previewHeight, previewWidth: previewWidth },
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, md: 12 },
                React.createElement(BlueGradientHeader, { type: "smallWithSub", showScanner: true, previewHeight: previewHeight },
                    React.createElement("p", null, "Inventory Counting"),
                    React.createElement("sub", null,
                        "Inventory List ",
                        React.createElement("b", null, "41")))),
            React.createElement(Grid, { item: true, md: 12, className: classes.whiteContentTopRadius, style: { height: previewHeight - 90 - 40 } },
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, md: 12 },
                        React.createElement(ScanContentBar, { text: scanContentBarText || InventoryCountingBinLocationsPage.defaultProps.scanContentBarText })),
                    React.createElement(Grid, { item: true, md: 12, className: classes.greyContentPlain, style: { height: previewHeight - 90 - 40 - 40 } }, isListPrefilled ?
                        React.createElement(Grid, { container: true }, (binLocationList === null || binLocationList === void 0 ? void 0 : binLocationList.length) > 0 &&
                            binLocationList.map((data) => (React.createElement(React.Fragment, null,
                                React.createElement(Grid, { item: true, md: 12, className: classes.whiteContentBar },
                                    React.createElement(Grid, { container: true },
                                        React.createElement(Grid, { className: classes.contentTitle, item: true, md: 12 }, "Bin Location"),
                                        React.createElement(Grid, { className: classes.blackLeftContent, item: true, md: 12 }, data.binLocation))),
                                React.createElement(Grid, { item: true, md: 12, className: classes.ContentBorder })))))
                        :
                            React.createElement(Grid, { container: true, justifyContent: "center", className: classes.noContentBar },
                                React.createElement("span", null,
                                    React.createElement("b", null, "Please Scan bin location")))))),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "left" }, "Back")),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "right" }, "Add")))));
};
InventoryCountingBinLocationsPage.defaultProps = {
    scanContentBarText: "Please scan wh/bin..."
};
export default React.memo(InventoryCountingBinLocationsPage);
